import { useCompanyFormContext } from '@/components/Companies/CompaniesFormProvider';
import CompanyFooter from '@/components/Companies/CompanyFooter';
import CompaniesSintegraForm from '@/components/Companies/CompanySintegraForm';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { CompanySintegraFormValues } from '@/core/domain/sintegra/Sintegra.types';
import { PageProps } from '@/types/PageProps';
import { Form } from 'antd';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

const CompanySintegraPage = ({ route }: PageProps) => {
  const intl = useIntl().formatMessage;
  const { companyId } = useRouteMatch<{ companyId: string }>().params;

  const { formValues, handleSubmit, disabled, forms, sintegraData } =
    useCompanyFormContext();

  const [form] = Form.useForm<CompanySintegraFormValues>(forms.companySintegra);

  useEffect(() => {
    if (sintegraData) {
      form.setFieldsValue(sintegraData);
    }
  }, [sintegraData]);

  useEffect(() => {
    if (formValues.companySintegra) {
      form.setFieldsValue(formValues.companySintegra);
    }
  }, [formValues.companySintegra]);

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      baseKey={companyId}
      basePath={`/app/registry/companies/${companyId}`}
      route={route.parent}
      extra={
        <SaveButton
          type="primary"
          onClick={handleSubmit}
          disabled={disabled}
          block
        >
          {intl({ id: 'commons.entity.save' })}
        </SaveButton>
      }
    >
      <CompaniesSintegraForm form={form} />

      <CompanyFooter disabled={disabled} />
    </DefaultRouteTabs>
  );
};

export default CompanySintegraPage;
